module.exports = __webpack_public_path__ + "img/ring_g_e_0_0@2x.008e7e92.png";